import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { jsonParse } from 'src/app/app.component';
import { FilesService } from 'src/app/controls/services/files/files.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qr-viewer',
  templateUrl: './qr-viewer.component.html',
  styleUrls: ['./qr-viewer.component.scss'],
  providers: [FilesService]
})
export class QRViewerComponent implements OnInit {

  qr_code_file_path = environment.SERVER_URL + 'getQRcode';
  guid;
  @Input() validation_obj;

  constructor(
    private file_service: FilesService,
    public dialogRef: MatDialogRef<QRViewerComponent>,
    private notification_svc : NotificationService

  ) { }

  ngOnInit(): void {
    this.generateQRCode();

  }

  generateQRCode() {
    this.file_service.getQRcode(this.validation_obj).subscribe(res => {

      if (res && res['data'] && res['status']) {
        res['data'] = jsonParse(res['data']);
        this.guid = res['data'].guid;
        this.qr_code_file_path += '?data=' + res['data'].link
      }
      else{
        this.notification_svc.snackbar(res['message'],'Close',5000);
        this.dialogRef.close()
      }
    },err=>{
      this.notification_svc.snackbar(err['message'],'Close',5000)
      this.dialogRef.close()
    })
  }
  closeDialog() {
    this.dialogRef.close(this.guid)
  }
}
